export class ContactProcessType {
  /// <summary>
  /// The none process
  /// </summary>
  static None = 0;

  /// <summary>
  /// The add process
  /// </summary>
  static Add = 1;

  /// <summary>
  /// The edit process
  /// </summary>
  static Edit = 2;

  /// <summary>
  /// The lookup
  /// </summary>
  static Lookup = 3;

  /// <summary>
  /// The select contact from account
  /// </summary>
  static SelectContactFromAccount = 4;

  /// <summary>
  /// The edit contact type
  /// </summary>
  static EditContactType = 5;

  /// <summary>
  /// Select contact from other agencies
  /// </summary>
  static SelectContactFromOtherAgencies = 6;

  /// <summary>
  /// Select close match people.
  /// </summary>
  static SelectContactFromCloseMatch = 7;
}

export class ContactAddressProcessType {
  /// <summary>
  /// The none process
  /// </summary>
  static None = 0;

  /// <summary>
  /// The add
  /// </summary>
  static Add = 1;

  /// <summary>
  /// The edit
  /// </summary>
  static Edit = 2;

  /// <summary>
  /// The deactive
  /// </summary>
  static Deactive = 3;

  /// <summary>
  /// The external validation
  /// </summary>
  static ExternalValidation = 4;

  /// <summary>
  /// The delete
  /// </summary>
  static Delete = 5;
}

export class APOEntityType {
  /// <summary>
  /// Address
  /// </summary>
  static Address = 'ADDRESS';

  /// <summary>
  /// Parcel
  /// </summary>
  static Parcel = 'PARCEL';

  /// <summary>
  /// Owner
  /// </summary>
  static Owner = 'OWNER';
}
